import { Box, Button } from '@mui/material';
import { memo } from 'react';

interface NavigationButtonsProps {
  onPrev: () => void;
  onNext: () => void;
  isNextDisabled: boolean;
  isPrevDisabled: boolean;
}
function NavigationButtons({ onPrev, onNext, isNextDisabled, isPrevDisabled }: NavigationButtonsProps): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: { xs: 2, md: 5 },
        alignItems: 'center',
      }}
    >
      <Button
        variant="outlined"
        onClick={onPrev}
        sx={{
          width: { xs: 80, md: 179 },
          height: { xs: 36, md: 50 },
          fontSize: { xs: '14px', md: '16px' },
        }}
        disabled={isPrevDisabled}
      >
        이전
      </Button>
      <Button
        variant="contained"
        onClick={onNext}
        sx={{
          width: { xs: 80, md: 179 },
          height: { xs: 36, md: 50 },
          fontSize: { xs: '14px', md: '16px' },
        }}
        disabled={isNextDisabled}
      >
        다음
      </Button>
    </Box>
  );
}

export default memo(NavigationButtons);
